module.exports = __webpack_public_path__ + "static/media/attendence.ebcfb22a.png";